import {
    ADD_RESERVATION,
    ADD_RESERVATION_SUCCESS,
    ADD_RESERVATION_FAILURE,
    GET_RESERVATIONS,
    GET_RESERVATIONS_SUCCESS,
    GET_RESERVATIONS_FAILURE,
    RESET_ADD_RESERVATION_STATE,
    RESET_RESERVATION_ACTIONS_STATE,
    IMPORT_RESERVATIONS_CSV,
    IMPORT_RESERVATIONS_CSV_FAILURE,
    IMPORT_RESERVATIONS_CSV_SUCCESS,
    RESET_IMPORT_RESERVATIONS_STATE,
    STORE_GUARD_RESERVATION_ID
} from './types';

export const addReservation = data => {
    return {
        type: ADD_RESERVATION,
        payload: data
    };
};

export const addReservationSuccess = data => {
    return {
        type: ADD_RESERVATION_SUCCESS,
        payload: data
    };
};

export const addReservationFailure = error => {
    return {
        type: ADD_RESERVATION_FAILURE,
        payload: error
    };
};

export const resetAddReservationState = () => {
    return {
        type: RESET_ADD_RESERVATION_STATE
    };
};

export const getReservations = () => {
    return {
        type: GET_RESERVATIONS
    };
};

export const getReservationsSuccess = data => {
    return {
        type: GET_RESERVATIONS_SUCCESS,
        payload: data
    };
};

export const getReservationsFailure = error => {
    return {
        type: GET_RESERVATIONS_FAILURE,
        payload: error
    };
};

export const resetReservationsActionState = () => {
    return {
        type: RESET_RESERVATION_ACTIONS_STATE
    };
};

export const importReservations = data => {
    return {
        type: IMPORT_RESERVATIONS_CSV,
        payload: data
    };
};

export const importReservationsSuccess = data => {
    return {
        type: IMPORT_RESERVATIONS_CSV_SUCCESS,
        payload: data
    };
};

export const importReservationsFailure = error => {
    return {
        type: IMPORT_RESERVATIONS_CSV_FAILURE,
        payload: error
    };
};

export const resetReservationImportState = () => {
    return {
        type: RESET_IMPORT_RESERVATIONS_STATE
    };
};

export const storeGuardResId = id => {
    return {
        type: STORE_GUARD_RESERVATION_ID,
        payload: id
    };
};
